/**
 * @module store/modules/apieditor/state
 * @description Initial state for the API Editor module.
 */

import { ApiEditorState } from "./types";

/**
 * Initial state for API Editor.
 *
 * @type {ApiEditorState}
 */
const state: ApiEditorState = {
  apis: {},
  contents: {},
  mappings: {},
};

export default state;
